import { configureStore } from "@reduxjs/toolkit";
import menuReducer from "./common/menuSlice";
import appStateReducer from "./common/appStateSlice";
import profileModalReducer from "./common/profileModalSlice";
import featuredTemplatesReducer from "./templates/templatesSlice";
import uiReducer from "./common/uiSlice";
import canvasReducer from "./editor/canvasSlice";
import avatarsReducer from "./avatars/avatarsSlice";
import assetsReducer from "./assets/assetsSlice";
import videoReducer from "./video/videoSlice";
import customeUploadReducer from "./customeUplaod/customeUploadSlice";
import mediaReducer from "./media/mediaSlice";
import slidesReducer from "./slides/slidesSlice";
import userReducer from "./user/userSlice";
import projectReducer from "./project/projectSlice";
import fontsReducer from "./common/fontsSlice";
import scriptReducer from "./script/scriptSlice";
import gridReducer from "./editor/GridCanvasSlice";
import subTitleReducer from "./Subtitle/subTitleSlice";
import AiDubbingReducer from "./AiDubbing/AiDubbingSlice";

const store = configureStore({
  reducer: {
    menu: menuReducer,
    ui: uiReducer,
    appState: appStateReducer,
    profileModal: profileModalReducer,
    templates: featuredTemplatesReducer,
    canvas: canvasReducer,
    avatars: avatarsReducer,
    assets: assetsReducer,
    video: videoReducer,
    uploder: customeUploadReducer,
    media: mediaReducer,
    slides: slidesReducer,
    user: userReducer,
    project: projectReducer,
    fonts: fontsReducer,
    script: scriptReducer,
    grid: gridReducer,
    subTitle: subTitleReducer,
    aiDubbing: AiDubbingReducer,
  },
});

export default store;
